import React, { ReactElement } from 'react';

const TOOLTIP_OFFSET_Y = 20;

const combineBounds = (elements: NodeListOf<Element>) => {
  if (elements.length === 1) {
    return elements[0].getBoundingClientRect();
  }

  const bounds = Array.from(elements).map((el) => el.getBoundingClientRect());

  const x = Math.min(...bounds.map((bound) => bound.x));
  const width = Math.max(...bounds.map((bound) => bound.width + bound.x)) - x;
  const y = Math.min(...bounds.map((bound) => bound.y));

  return { x, width, y };
};

const getPosition = (bfs: string, wrapperRef: React.MutableRefObject<HTMLDivElement>) => {
  if (!wrapperRef.current) {
    return null;
  }

  const element = wrapperRef.current.querySelectorAll(`[agis\\:gmdnr="${bfs}"]`);

  if (!element.length || !wrapperRef.current) {
    return null;
  }

  const { x, width, y } = combineBounds(element);
  const { x: wrapperX, y: wrapperY } = wrapperRef.current.getBoundingClientRect();

  return {
    x: x + width / 2 - wrapperX,
    y: y - wrapperY - TOOLTIP_OFFSET_Y,
  };
};

interface Props {
  title: string;
  bfsNumber: string;
  wrapperRef: React.MutableRefObject<HTMLDivElement>;
  result?: ReactElement;
}

const MapTooltip = ({ title, bfsNumber, wrapperRef, result }: Props) => {
  const position = getPosition(bfsNumber, wrapperRef);
  if (!position) return null;

  return (
    <div
      className="wap__map-tooltip"
      aria-hidden
      style={{
        transform: `translate(calc(${position.x}px - 50%), calc(${position.y}px - 100%))`,
      }}
    >
      <div>{title}</div>
      {result}
    </div>
  );
};

export default MapTooltip;
